import { useTheme } from '../contexts/ThemeContext';

const swatches = [
  { key: 'matrix',  color: '#2cff75', label: 'Matrix'  },
  { key: 'cyan',    color: '#23d8ff', label: 'Cyan'    },
  { key: 'sunset',  color: '#ff8f32', label: 'Sunset'  },
  { key: 'magenta', color: '#ff4ac9', label: 'Magenta' },
];

export default function ThemeSwitcher({ compact = false }) {
  const { themeName, setTheme } = useTheme();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      {!compact && (
        <span style={{ fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
          Theme
        </span>
      )}
      {swatches.map(({ key, color, label }) => (
        <button
          key={key}
          title={label}
          onClick={() => setTheme(key)}
          style={{
            width: compact ? 10 : 14,
            height: compact ? 10 : 14,
            borderRadius: '50%',
            background: color,
            border: themeName === key
              ? `2px solid var(--text)`
              : '2px solid transparent',
            outline: themeName === key ? `1px solid ${color}` : 'none',
            outlineOffset: 1,
            cursor: 'pointer',
            padding: 0,
            flexShrink: 0,
          }}
        />
      ))}
    </div>
  );
}
